var render, staticRenderFns
import script from "./BindsPopover.vue?vue&type=script&lang=js&"
export * from "./BindsPopover.vue?vue&type=script&lang=js&"
import style0 from "./BindsPopover.vue?vue&type=style&index=0&id=0cfc8d2f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports